import React, { useMemo } from 'react';

import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTachometerAlt, faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

interface Props {
  sidebarOpen: boolean;
  setSidebarOpen: (v: boolean) => void;
}

const Sidebar = ({ sidebarOpen, setSidebarOpen }: Props): React.ReactElement => {
  const { t } = useTranslation('sidebar');
  const navItems = useMemo(() => {
    return [
      {
        id: 'root',
        name: 'Raunfærnimat',
        toggle: false,
        show: () => true,
        items: [
          {
            id: 'dashboard',
            name: t('dashboard'),
            to: '/',
            icon: faTachometerAlt,
            show: () => true,
            // active: () => this.$route.path === '/',
          },
          // {
          //   id: 'applications',
          //   name: t('applications'),
          //   to: '/umsoknir',
          //   icon: faClipboardCheck,
          // },
          // {
          //   id: 'questionnaires',
          //   name: t('questionnaires'),
          //   to: '/matslistar',
          //   icon: faList,
          // },
        ],
      },
    ];
  }, [t]);

  return (
    <ul
      className={classNames('navbar-nav bg-dark sidebar sidebar-dark accordion pt-4', {
        toggled: sidebarOpen,
      })}
      id="accordionSidebar"
    >
      {/* <Link className="sidebar-brand d-flex align-items-center justify-content-center my-2" to="/">
        RFM
      </Link> */}

      {navItems
        .filter((i) => i.show())
        .map((navItem) => (
          <div key={navItem.id}>
            <div
              className={classNames('sidebar-heading', {
                'cursor-pointer': navItem.toggle,
              })}

              // @click.prevent="toggleNavbarOpened(navItem.toggle)"
              // v-if="navItem.name && navItem.show()"
            >
              {navItem.name}
              {/* <template v-if="navItem.toggle">
          <font-awesome-icon
            class="d-none"
            :class="{ 'd-md-inline-block': !sideNavToggled }"
            icon="angle-right"
            fixed-width
            v-if="!navbar[navItem.toggle]"
          />
          <font-awesome-icon class="d-none" :class="{ 'd-md-inline-block': !sideNavToggled }" icon="angle-down" fixed-width v-else />
        </template> */}
            </div>
            {navItem.items.map((item) => (
              <li key={item.id} className={classNames('nav-item')}>
                <NavLink exact to={item.to} className="nav-link" activeClassName="active">
                  {item.icon && <FontAwesomeIcon v-if="icon" className="nav-link-icon" fixedWidth icon={item.icon} />} <span>{item.name}</span>
                </NavLink>
              </li>
            ))}

            <hr className="sidebar-divider" />
          </div>
        ))}

      <div className="text-center d-none d-md-inline">
        <button type="button" className="rounded-circle border-0 sidebarToggle" onClick={() => setSidebarOpen(!sidebarOpen)}>
          <FontAwesomeIcon className="sidebarToggleIcon" icon={sidebarOpen ? faAngleRight : faAngleLeft} />
        </button>
      </div>
    </ul>
  );
};

export default Sidebar;
